if (!customElements.get('accordion-item')) {
  class AccordionItem extends customElements.get('dropdown-disclosure') {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        if (this.querySelector('details')) {
          this.querySelector('details').open = false;
        }
        this.init();
      });
    }

    open(summaryElement, detailsElement) {
      setTimeout(() => {
        detailsElement.classList.add('is-open');
      }, 200);

      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(detailsElement, summaryElement);
    }
  }

  customElements.define('accordion-item', AccordionItem);
}
